exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".photo-upload input[type=file]{display:none}.photo-upload .add,.photo-upload .photo{float:left;position:relative;width:40px;height:40px;background:#aaa;margin:8px 10px 0 0}.photo-upload .photo img{width:40px}.photo-upload .photo .remove{position:absolute;top:-8px;right:-8px;background:#000;color:#fff;border-radius:20px;width:16px;height:16px;text-decoration:none;text-align:center;font-size:10px;vertical-align:middle}.photo-upload .add{font-size:20px;font-weight:700;text-align:center;padding-top:5px;box-sizing:border-box;color:#555;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7da22692","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/photo-upload.vue
// module id = 81
// module chunks = 0 1